const LeadersItem = ({data}) => {
  const {img, name, job, text, style = {}} = data;

  return (
    <div className='leaders-item'>
      <div className='leader-img' style={{backgroundImage: `url(${img})`, ...style}}></div>
      <div className='slide-content'>
        <h4 className='leader-name'>{name}</h4>
        <p className='leader-job'>{job}</p>
        <p className='leader-text'>{text}</p>
      </div>
    </div>
  );
};

export default LeadersItem;

